import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { ColorSchemeSwitcherComponent } from './color-scheme-switcher.component';
import { ColorSchemeService } from '@fantaz/shared/services/color-scheme';

@NgModule({
  imports: [MaterialModule, CommonModule, MatSlideToggleModule],
  providers: [ColorSchemeService],
  declarations: [ColorSchemeSwitcherComponent],
  exports: [ColorSchemeSwitcherComponent],
})
export class SharedUiColorSchemeSwitcherModule {}
